import styled from 'styled-components';
import { FlexColumn } from '../../Flex';
import { ChatStarterAction } from '../types';
import { space } from '../../../style/utils';
import TextMessageRenderer from './TextMessageRenderer';
import UserActionButtons from './UserActionButtons';

const Wrapper = styled(FlexColumn)<{ $maxWidth?: number }>`
  gap: ${space('md')};
  width: 100%;
  ${({ $maxWidth }) =>
    $maxWidth &&
    `
    max-width: ${$maxWidth}px;
    margin: 0 auto;
  `}
`;

type Props = {
  message: string;
  actions: ChatStarterAction[];
  disabled?: boolean;
  onSelectAction: (prompt: string) => void;
  maxWidth?: number;
};

const StarterMessage = ({
  message,
  actions,
  disabled,
  onSelectAction,
  maxWidth,
}: Props) => (
  <Wrapper $maxWidth={maxWidth}>
    <TextMessageRenderer text={message} />
    <UserActionButtons
      actions={actions.map((a) => a.label)}
      disabled={disabled}
      onSelect={(label) =>
        onSelectAction(actions.find((a) => a.label === label)?.prompt ?? label)
      }
    />
  </Wrapper>
);

export default StarterMessage;
